export const SHOW_UNSAVED_CHANGES_CSS_CLASS_NAME = "show-unsave-changes";